export default __webpack_public_path__ + "static/media/Helm of Writhing.38ac1b17.jpg";